module.exports = __webpack_public_path__ + "static/media/benefits.000ea7b7.png";